export const EventRadius = 4
export const MidPointRadius = 2.5
export const RangePadding = 8
export const EventRatio = 1.25 // 25% more hitarea